module.exports = __webpack_public_path__ + "static/media/CK.43e8919f.svg";